// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"VerticalMenu__menuContainer___1ExMy"};